<div class="center-container">
  <div class="image-column" *ngIf="imagePosition === 'left' && !(breakpoints$ | async)?.m_down">
    <ng-container [ngSwitch]="true">
      <img *ngSwitchCase="(breakpoints$ | async)?.xxl" src="assets/registration-large.jpg" alt="Image" class="responsive-image" />
      <img *ngSwitchCase="(breakpoints$ | async)?.xl" src="assets/registration-medium.jpg" alt="Image" class="responsive-image" />
      <img *ngSwitchDefault src="assets/registration-small.jpg" alt="Image" class="responsive-image" />
    </ng-container>
  </div>

  <div class="form-column">
    <div style="width: 100%;">
      <ng-container *ngComponentOutlet="formComponent; injector: formInjector"></ng-container>
    </div>
  </div>

  <div class="image-column" *ngIf="imagePosition === 'right' && !(breakpoints$ | async)?.l_down">
    <ng-container [ngSwitch]="true">
      <img *ngSwitchCase="(breakpoints$ | async)?.xxl" [src]="imageSrc" alt="Image" class="responsive-image" />
      <img *ngSwitchCase="(breakpoints$ | async)?.xl" [src]="imageSrc" alt="Image" class="responsive-image" />
    </ng-container>
  </div>
</div>
